import ajaxRequest from '@/utils/request';

const state = {
    recurrent: null,
    nextPayAmount: null,
    payedTo: null,
    isExpired: null,
    isExpiringToday: null,
    pricesAndDiscounts: [],
    restriction: null
};

const getters = {
    payedToDisplay(state) {
        let payedTo = new Date(state.payedTo);
        return payedTo && payedTo.toLocaleDateString('ru-RU');
    }
};

const actions = {
    getTariffPlanState(context) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/payments/tariff_plan_state/get/',
                success(response) {
                    context.commit('setTariffPlanState', {
                        resolve,
                        data: response.data
                    });
                }
            });
        });
    },
    rejectAutoPayment(context) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/payments/reject_auto_payment/',
                method: 'POST',
                success(response) {
                    context.commit('setTariffPlanState', {
                        resolve,
                        data: response.data
                    });
                }
            });
        });
    }
};

const mutations = {
    setTariffPlanState(state, {resolve, data}) {
        state.recurrent = data.recurrent;
        state.nextPayAmount = data.next_pay_amount;

        state.payedTo = data.payed_to;
        state.isExpired = data.is_expired;
        state.isExpiringToday = data.is_expiring_today;
        state.pricesAndDiscounts = data.prices_and_discounts;
        state.restriction = data.restriction;

        resolve && resolve();
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/payments.js